/* eslint-disable no-shadow */
/* eslint-disable no-constant-condition */
/* eslint-disable camelcase */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Card, CardContent } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Popover from "@material-ui/core/Popover";
import { withRouter } from "react-router-dom";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { GenericLoader } from "../../../shared/widgets";
import { indianNSConverter } from "../../../shared/methods/indianNSConverter";
import { templateStrings, amountFields, doubleFields } from "../../../Constant";
import "./overview.css";

const styles = {
  root: {
    height: "100%",
  },
  cardWrapper: {
    borderRadius: "0px",
  },
  cardContentWrapper: {
    paddingBottom: "16px !important",
  },
  popOverClass: {
    borderRadius: "none",
  },
};

const fractionalLimit = (value) => value?.toLocaleString(undefined, { maximumFractionDigits: 2 });

// eslint-disable-next-line default-param-last
const getValueStyle = (value, column, isWithUnits, setHoveredValue = () => { }, renderPopOver) => {
  if (doubleFields[`${column}`] !== undefined) {
    let percent = "";
    const element = Object.entries(value).map((key) => {
      const fieldName = doubleFields[`${column}`][key[0]].displayName;
      const { isExpandable } = doubleFields[`${column}`][key[0]];
      const { expandableType } = doubleFields[`${column}`][key[0]];
      const clonedValue = fractionalLimit(key[1]);
      const noOfThousands = Math.abs(key[1]) / 1000;
      if (["Amount", "Ridership"].includes(key[0])) percent = "%";

      // in indian numbering system
      const indianNumberSystemFields = [
        "totalRidership",
        "digitalRidership",
        "amountPaid",
        "amountReceived",
        "toBePaid",
        "toBeReceived",
      ];
      if (indianNumberSystemFields.includes(key[0])) {
        return (
          <div
            key={key}
            className="digital-grid"
            onMouseEnter={() => { setHoveredValue(noOfThousands >= 1 ? clonedValue : null); }}
            onMouseLeave={() => { setHoveredValue(null); }}
          >
            <div>{`${fieldName} :`}</div>
            <div className="pointer-cursor font-weight-600">
              &nbsp;
              {` ${indianNSConverter(key[1])}${percent}`}
            </div>
            {/* Renders popover to view breakdown */}
            {renderPopOver(isExpandable, expandableType, expandableType)}
          </div>
        );
      }
      return (
        <div key={key} className="digital-grid">
          <div>{`${fieldName} :`}</div>
          <div className="font-weight-600">
            {` ${clonedValue}${percent}`}
          </div>
        </div>
      );
    });
    return <div className="digital-field inr-unit">{element}</div>;
  }

  if (amountFields[`${column}`] !== undefined) {
    const clonedValue = fractionalLimit(value);
    const noOfThousands = Math.abs(value) / 1000;
    return (
      <p
        className="inr-unit pointer-cursor"
        onMouseEnter={() => { setHoveredValue(noOfThousands >= 1 ? `₹${clonedValue}` : null); }}
        onMouseLeave={() => { setHoveredValue(null); }}
      >
        <span>{["totalGpsDistance"].includes(column) ? "" : "₹"}</span>
        {" "}
        {isWithUnits ? indianNSConverter(value) : clonedValue}
      </p>
    );
  }
  return fractionalLimit(value);
};
class GridList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pop_open: false,
      hoveredValue: null,
    };

    this.breakDown = {
      averageBuses: 0,
      totalCollection: 0,
      operatorPayout: 0,
      balanceLoaded: 0,
      walletUsage: 0,
      epkm: 0,
      totalPassengerCount: 0,
      Amount: 0,
      Ridership: 0,
      totalRidership: 0,
      digitalRidership: 0,
      cardsSold: 0,
      passesSold: 0,
      rechargesDone: 0,
      mobileTicketsSold: 0,
      mobilePassesSold: 0,
      mobileRechargesDone: 0,
      exitBuses: 0,
      totalGpsDistance: 0,
      digitalDiscountByChalo: 0,
      ticketSalesAmount: 0,
      passSalesAmount: 0,
      onlineRecharge: 0,
      amountPaid: 0,
      amountReceived: 0,
      toBePaid: 0,
      toBeReceived: 0,
      other: 0,
      penalty: 0,
      fuelExpense: 0,
      associationFee: 0,
      maintenance: 0,
      helper: 0,
      conductorSalary: 0,
      tollAmount: 0,
      driverSalary: 0,
      cleaning: 0,
      totalRechargeCashAmt: 0,
      totalIssueCardCashAmt: 0,
      totalPassIssueCashAmt: 0,
      totalRechargeCardSold: 0,
      ticketByPrepaidCard: 0,
      mobileTicketResidualAmount: 0,
      upiTicketAmount: 0,
      mobileTicketAmount: 0,
      passIssueProductCost: 0,
      dailyPassAmount: 0,
      cardFee: 0,
      scanPayAmount: 0,
      chaloPayAmount: 0,
      ncmcPrepaidAmount: 0,
      convenienceFee: 0,
      contractualAmount: 0,
      prepaidPassengerCount: 0,
      mobileticketPassengerCount: 0,
      mobilepassPassengerCount: 0,
      passPassengerCount: 0,
      chaloPayPassengerCount: 0,
      ncmcPrepaidPassengerCount: 0,
      scanpayPassengerCount: 0,
      upiPassengerCount: 0,
      gcEdit: 0,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleOpenPopUp = this.handleOpenPopUp.bind(this);
  }

  handleOpenPopUp(e) {
    const { pop_open } = this.state;
    e.preventDefault();
    this.setState({
      pop_open: !pop_open,
      anchorEl: e.currentTarget,
    });
  }

  handleClose() {
    this.setState({
      pop_open: false,
    });
  }

  renderPopOver = (isExpandable, expandableType, template) => {
    const { classes, gridItemsData } = this.props;
    const { pop_open, anchorEl } = this.state;

    if (isExpandable) {
      return (
        <div>
          <div className="pointer-cursor">{pop_open ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
          <Popover
            className={{ root: classes.popOverClass }}
            open={pop_open}
            anchorEl={anchorEl}
            onClose={this.handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div className="expenseWrapper">
              <div className="expenseWrapperTitle">Breakdown</div>
              <div>
                {templateStrings[expandableType]
                  && Object.keys(templateStrings[expandableType]).map(
                    (column, index) => {
                      const breakDownStrings = templateStrings[expandableType];

                      if (gridItemsData && gridItemsData.expenseBreakDown) {
                        this.breakDown = gridItemsData[`${template}BreakDown`];
                      }

                      const breakDownColumnValue = this.breakDown && this.breakDown[column];

                      return (
                        <div key={index} className="row-wrapper">
                          <div>{breakDownStrings[column]}</div>
                          <div>
                            {this.breakDown
                            && getValueStyle(
                              breakDownColumnValue,
                              column,
                              undefined,
                              undefined,
                              this.renderPopOver.bind(this),
                            )}
                          </div>
                        </div>
                      );
                    },
                  )}
              </div>
            </div>
          </Popover>
        </div>
      );
    }
    return null;
  };

  navigate = () => {
    const { history } = this.props;
    history.push("/collection/card-collection");
  };

  render() {
    const {
      classes, template, type, value, gridItemsData = "", isLoading = false, containerClass,
    } = this.props;
    const { hoveredValue } = this.state;

    const gridStrings = templateStrings[type];
    const isExpandable = gridStrings[template].isExpandable
      && gridStrings[template].expandableType;
    // const expenseBreakDownStrings = templateStrings.expensesBreakdown;

    if (gridItemsData && gridItemsData.expenseBreakDown) {
      this.breakDown = gridItemsData.expenseBreakDown;
    }
    return (
      <Card
        onClick={
          gridStrings[template].navigationAllowed ? this.navigate : this.handleOpenPopUp
        }
        className={`${classes.cardWrapper} ${containerClass}`}
      >
        <CardContent className={classes.cardContentWrapper}>
          <div className="text-icon-wrapper">
            <div className={`grid-title ${isExpandable && "pointer-cursor"}`}>{gridStrings[template].displayName}</div>
            {/* Renders popover to view breakdown */}
            {this.renderPopOver(
              isExpandable,
              gridStrings[template].expandableType,
              template,
              gridItemsData,
            )}
            {gridStrings[template] && gridStrings[template].navigationAllowed && (
              <div>
                <ChevronRightIcon />
              </div>
            )}
          </div>
          <div className={template === "digitalMeta" || "mobileProducts" ? "grid-content flex-direction-column padding-zero" : "grid-content flex-direction-column"}>
            {(isLoading && <GenericLoader />)
              || (
                getValueStyle(value, template, true, (value) => {
                  this.setState({ hoveredValue: value });
                }, this.renderPopOver.bind(this))
              )}
            <div className="display-flex flex-center inr-value-wrap">
              <span className="inr-value">
                {hoveredValue && "Original Value: "}
                {" "}
                {hoveredValue}
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(withRouter(GridList));
